import React from "react";
import { team } from "../../styles/theme";

import JoshiImg from "../../assets/images/team/Trupti.jpg";
import ZhenImg from "../../assets/images/team/Zhen.jpg";

const principalInvestigator = {
  name: "Dr. Trupti Joshi",
  role: "Principal Investigator",
  title: "Senior Associate Dean for Informatics & Population Analytics",
  img: JoshiImg,
};

const teamMembers = [
  {
    name: "Zhen Lyu",
    role: "Developer, Web & Bioinformatics",
    title: "Post Doctoral Fellow",
    img: ZhenImg,
  },
];

const Team = () => {
  return (
    <section style={team.section}>
      
      <h2 style={team.mainTitle}>
        Our Team & Resources
      </h2>

      {/* PI Section */}
      <div style={team.piWrapper}>
        <h3 style={team.subTitle}>
          Principal Investigator
        </h3>

        <div style={team.cardLarge}>
          <img
            src={principalInvestigator.img}
            alt={principalInvestigator.name}
            style={team.imageLarge}
          />

          <h4 style={team.nameLarge}>
            {principalInvestigator.name}
          </h4>

          <p style={team.role}>
            {principalInvestigator.role}
          </p>

          <p style={team.title}>
            {principalInvestigator.title}
          </p>
        </div>
      </div>

      {/* Team Section */}
      <div>
        <h3 style={team.subTitle}>
          Team Members
        </h3>

        <div style={team.teamContainer}>
          {teamMembers.map((member, idx) => (
            <div key={idx} style={team.card}>
              <img
                src={member.img}
                alt={member.name}
                style={team.image}
              />

              <h4 style={team.name}>
                {member.name}
              </h4>

              <p style={team.role}>
                {member.role}
              </p>

              <p style={team.title}>
                {member.title}
              </p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default Team;